<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="sy-im-head syue-clr">
    <div class="title syue-left">
      <img :src="syImgUrl+'16284754456395441.svg'" >
      留言板
    </div>
    <div class="syue-right sy-im-close">
      <i class="el-icon-close" @click="hideIm"></i>
    </div>
  </div>
</template>

<script>
import mixin from './../mixin'

export default {
  mixins: [ mixin ],
  props: {
    activeMsgItem: {
      type: Object
    },
    toUserInfo: {
      type: Object
    }
  },
  methods: {
    hideIm () {
      this.$emit('hideIm')
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
.sy-im-head{
  height: 34px;
  box-sizing: border-box;
  padding: 0px 16px;
  background: #363E55;
  .title{
    line-height: 34px;
    color: #fff;
    font-size: 12px;
    img{
      display: inline-block;
      vertical-align: middle;
    }
  }
  
  .sy-im-close{
    padding-top: 8px;
    .el-icon-close{
      cursor: pointer;
      color: #EEEEEE;
      font-size: 18px;
    }
  }
}
</style>